import { useState } from 'react';
import { Button } from 'antd';

import TerminateAssignmentModal from '../TerminateAssignmentModal';
import { AssignmentTerminationModel } from 'api/backofficeApiClient';
import { TerminationModeEnum } from '../TerminateAssignmentModal/TerminateAssignmentModal';
import { AssignmentStatusTypeEnum } from 'api/adminApiClient';

type Props = {
  assignmentId?: string;
  assignmentTerminationDetails?: AssignmentTerminationModel;
  assignmentStatus?: AssignmentStatusTypeEnum;
};

export default function TerminationInfoModal(props: Props) {
  const { assignmentId, assignmentTerminationDetails, assignmentStatus } =
    props;
  const [isTerminationDisplayModel, setIsTerminationDisplayModel] =
    useState(false);
  const isPendingAssignment =
    assignmentStatus === AssignmentStatusTypeEnum.Request;

  const handleTerminationModelOpen = () => {
    setIsTerminationDisplayModel(true);
  };

  const handleTerminationModelClose = () => {
    setIsTerminationDisplayModel(false);
  };

  return (
    <>
      {isTerminationDisplayModel && (
        <TerminateAssignmentModal
          onClose={handleTerminationModelClose}
          assignmentId={assignmentId as string}
          assignmentTerminationDetails={assignmentTerminationDetails}
          mode={TerminationModeEnum.View}
          title="Termination info"
          isPendingAssignment={isPendingAssignment}
        />
      )}
      <div>
        <Button onClick={handleTerminationModelOpen}>
          View Termination Info
        </Button>
      </div>
    </>
  );
}
